import React, { useState,useEffect } from "react";
import CustomAccordian from "../dms_common/CustomAccordian";
import "./InvoiceDetailsCard.css";
import { invoiceDeliveryStatusConfig,InvoiceDetailsCardProps } from "../../types/types";

const InvoiceDetailsCard: React.FC<InvoiceDetailsCardProps> = ({ invoiceDetails,invoiceReturnAmount, deliveryStatus, isPartialDeliveryAllowed, isExpanded, setIsExpanded }) => {
  const [formattedInvoiceDetails, setFormattedInvoiceDetails] = useState({...invoiceDetails,invoiceReturnAmount,});

  const invoiceDeliveryStatusMapping: invoiceDeliveryStatusConfig[] = [
    {
      id: "INVOICED",
      dmsLabelColor: "#CC911F",
      dmsLabel: "Pending",
      dmsColor: "#FFF9EF",
    },
    {
      id: "DELIVERED",
      dmsLabelColor: "#029847",
      dmsLabel: "Delivered",
      dmsColor: "#EAFFF4",
    },
    {
      id: "CANCELLED",
      dmsLabelColor: "#ce4632",
      dmsLabel: "Cancelled",
      dmsColor: "#fefaf7",
    },
    {
      id: "PARTIAL DELIVERED",
      dmsLabelColor: "#17B4A3",
      dmsLabel: "Partially Delivered",
      dmsColor: "#F0FBFF",
    },
  ]

  const loadoutMetaData = [
    {
      keys: "loadNumber",
      label: "Loadout No.",
      index: 1,
    },
    {
      keys: "deliveryDate",
      label: "Delivery Date",
      index: 2,
    },
    {
      keys: "modeOfDelivery",
      label: "Mode of Delivery",
      index: 3,
    },
    {
      keys: "outletName",
      label: "Outlet Name",
      index: 4,
    },
    {
      keys: "outletCode",
      label: "Outlet Code",
      index: 5,
    },
    {
      keys: "skuCount",
      label: "SKUs",
      index: 6,
      valueType: "number",
    },
  ];

  const amountMetaData = [
    {
      keys: "totalAmount",
      label: "Amount",
      index: 1,
      valueType: "number",
      currencySymbol: "₹",
    },
    {
      keys: "taxAmount",
      label: "Tax Amount",
      index: 2,
      valueType: "number",
      currencySymbol: "₹",
    },
    {
      keys: "discountAmount",
      label: "Discount Amount",
      index: 4,
      valueType: "number",
      currencySymbol: "₹",
    },
    {
      keys: "finalAmount",
      label: "Final Amount",
      index: 5,
      valueType: "number",
      currencySymbol: "₹",
    },
    {
      keys: "invoiceReturnAmount",
      label: "Return Amount",
      index: 6,
      valueType: "number",
      currencySymbol: "₹",
    },
  ];

  const onCustomAccordionToggle = (isExpanded: boolean) =>{
    setIsExpanded(!isExpanded);
  }

  useEffect(() => {
    setFormattedInvoiceDetails((prevDetails) => ({
      ...prevDetails,
      amount: invoiceDetails.amount === 0 ? "-" : invoiceDetails.amount,
      taxAmount: invoiceDetails.taxAmount === 0 ? "-" : invoiceDetails.taxAmount,
      discountAmount: invoiceDetails.discountAmount === 0 ? "-" : invoiceDetails.discountAmount,
      finalAmount: invoiceDetails.finalAmount === 0 ? "-" : invoiceDetails.finalAmount,
      invoiceReturnAmount: invoiceReturnAmount === 0 ? "-" : invoiceReturnAmount,
    }));
  }, [invoiceDetails, invoiceReturnAmount]);


  return (
    <div className="invoice-details-card">
      <CustomAccordian
        expanded={!isExpanded}
        onCustomAccordionToggle={onCustomAccordionToggle}
        header={`Invoice No. ${invoiceDetails.invoiceSerialNumber || invoiceDetails.invoiceNumber}`}
        status={deliveryStatus ?? "INVOICED"}
        statusConfig={invoiceDeliveryStatusMapping} 
        metaData1={loadoutMetaData}
        data1={formattedInvoiceDetails}
        metaData2={amountMetaData.filter((metaData) => metaData.keys !== "invoiceReturnAmount")}
        data2={formattedInvoiceDetails}
        label1="Loadout Info"
        label2="Amount Info"
        isSecondHalf={true}
        singleColumnInEachHalf={false}
      />
    </div>
  );
};

export default InvoiceDetailsCard;